import React from 'react';
import CrossRoad from "../UI/Crossroad";

const Crossroad_9ABlue_13CRed = () => <CrossRoad coords="1723.000000, 1341.000000"/>;

export default Crossroad_9ABlue_13CRed;
